import React from "react";

const BONUS_EVERY = 10; // ทุก 10 วันต่อเนื่องได้โบนัส (ค่าเริ่มต้นของระบบ)
const addDays = (ymd, n) => {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
};
const wd = (ymd) => new Date(`${ymd}T00:00:00Z`).toLocaleDateString("th-TH", { weekday: "short", timeZone: "UTC" });

/** ปฏิทิน 7 วัน (วันนี้อยู่กลาง) — วันที่เช็คอินแล้วดูจาก history เดือนนี้ + ช่วงสตรีคต่อเนื่อง ; วันอนาคตแสดงรางวัลโดยประมาณ */
export default function CheckinWeek({ status }) {
  const { today, history = [], streak = 0, lastCheckIn, canClaim, dailyCoins, bonusToday } = status;
  const claimedOn = (d) => history.includes(d) || (!!lastCheckIn && streak > 0 && d <= lastCheckIn && d > addDays(lastCheckIn, -streak));
  const base = canClaim ? streak + 1 : streak; // ลำดับสตรีคของ "วันนี้"
  const days = [-3, -2, -1, 0, 1, 2, 3].map((k) => {
    const date = addDays(today, k);
    const done = claimedOn(date);
    const isToday = k === 0;
    const bonus = k === 0 ? bonusToday > 0 : k > 0 && (base + k) % BONUS_EVERY === 0;
    return { date, k, done, isToday, bonus, state: done ? "done" : isToday ? "today" : k < 0 ? "past" : "future" };
  });
  return (
    <div className="week" role="list" aria-label="ปฏิทินเช็คอิน 7 วัน">
      {days.map((d) => (
        <div key={d.date} role="listitem" className={`day is-${d.state}`} aria-label={`${wd(d.date)} ${Number(d.date.slice(8))} ${d.done ? "เช็คอินแล้ว" : d.isToday ? "วันนี้" : ""}`}>
          {d.isToday ? <span className="day__tag">วันนี้</span> : <span className="day__wd">{wd(d.date)}</span>}
          <span className="day__no">{Number(d.date.slice(8))}</span>
          <span className="day__coin" aria-hidden="true">{d.done ? "✓" : ""}</span>
          <span className="day__amt">{d.state === "past" ? "" : `+${dailyCoins}`}</span>
          {d.bonus ? <span className="day__bonus">โบนัส</span> : null}
        </div>
      ))}
    </div>
  );
}

export { BONUS_EVERY };
